import {translations as defaultTranslation} from '../i18n'

export const translations = {
	fr: {
		score: 'score',
		auditScores: 'notes d\'audits'
	}
}

export default {...defaultTranslation.fr, ...translations.fr}


// WEBPACK FOOTER //
// ./lib/audit/i18n.js